export const defaultLocale = "nl-be";

export const baseUrl = "https://www.spuntini.be";
